<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Structure Count Report
      </h2>
      <p class="tw-italic tw-text-gray-700">
      </p>
    </b-container>

    <b-row>
      <b-col>
        <b>Download CSV file </b><i @click="downloadFile" class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download CSV"></i>
        <b-alert v-if="csvLoading" variant="info" show>Downloading...<i class="fas fa-spin fa-spinner"></i></b-alert>
      </b-col>
    </b-row>

    <br />

    <div style="width: 100%; overflow: auto;">
      <b-table
        striped
        hover
        sticky-header="70vh"
        :items="data"
        :fields="fields"
      />
    </div>

    <b-alert v-if="loading" variant="info" show>Loading... <i class="fas fa-spin fa-spinner"></i></b-alert>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      loading: false,
      csvLoading: false,
      loadingError: false,
      csvLoadingError: false,
      // set label for display header
      fields: [
        { key: 'cluster', label: 'Cluster'},
        { key: 'et_or_control', label: 'ET or Control'},
        { key: 'structure_count_all', label: 'Structure Count All'},
        { key: 'structure_with_et_installed', label: 'Structure With Eave Tubes Installed'},
      ],
      data: [],
    };
  },
  mounted: function() {
    const that = this;
    that.loading = true;
    // generalized data request
    HTTP.get('/eavetubes/structure-count-report/'
    ).then((response) => {
      that.loading = false;
      that.data = response.data.data;
    }).catch((error) => {
      that.loading = false;
      that.loadingError = true;
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    downloadFile: function(){
      const that = this;
      that.csvLoading = true;
      let params = {
        return_as: 'csv',
      }
      HTTP.get('/eavetubes/structure-count-report/', {params: params})
      .then(response => {
          var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
					// date format: yyyy-mm-dd
					const filename = 'ET_StructureCount-' + (new Date().toLocaleDateString('en-CA')) + '.csv';
          fileLink.setAttribute("download", filename);
          document.body.appendChild(fileLink);
          fileLink.click();
          that.csvLoading = false;
      }).catch((error) => {
        that.csvLoading = false;
        that.csvLoadingError = true;
        HandleErrors.HandleErrors(error);
      });
    },
  }
};
</script>

<style>
.buffer-20{
  margin-right: 20px;
  margin-bottom: 20px;
}
</style>
